<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header">
            <h4>{{ $t('reservations.add') }}</h4>
          </div>
          <div class="card-body">
            <ReservationsForm @form-submitted="formSubmitted" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ReservationsForm from './ReservationsForm.vue';
import router from '@/router';

export default {
  components: {
    ReservationsForm
  },
  methods: {
    formSubmitted() {
      router.push({ name: 'ReservationsList' });
    }
  }
}
</script>
